import React from 'react';

import useAccountManager from '../../hooks/useAccountManager';

import BaseErrorPage from './BaseErrorPage';

const AppShellErrorPage = ({
  errorCode,
  userName,
}: {
  errorCode?: number;
  userName?: string;
}): JSX.Element => {
  const { data: accountManager } = useAccountManager();
  return (
    <BaseErrorPage
      errorCode={errorCode}
      userName={userName}
      accountManager={accountManager}
    />
  );
};

export default AppShellErrorPage;
